import { mockResponse, request, isMockMode } from './client.js';

// 角色管理 API。後端尚未實作，目前一律走 mock（資料存記憶體，重整後 reset）。
// 後端做好後，在 .env 設 REACT_APP_USE_MOCK_ROLES=false 即可切到真實後端，本檔不用改。
//
// Role 形狀：{ id, name(代號/slug), displayName(顯示名), permissions: string[], isSystem }

let _roles = [
  { id: 1, name: 'master',       displayName: '系統管理員', permissions: ['theme', 'product', 'catalog', 'order', 'users', 'roles'], isSystem: true },
  { id: 2, name: 'customer',     displayName: '一般會員',   permissions: [], isSystem: true },
  { id: 3, name: 'theme_editor', displayName: '主題編輯員', permissions: ['theme'], isSystem: false },
];
let _nextId = 4;

const clone = (r) => ({ ...r, permissions: [...r.permissions] });

export function adminGetRoles() {
  if (!isMockMode('roles')) return request('/api/admin/roles');
  return mockResponse(() => _roles.map(clone));
}

export function adminCreateRole(data) {
  if (!isMockMode('roles')) return request('/api/admin/roles', { method: 'POST', body: data });
  return mockResponse(() => {
    const role = {
      id: _nextId++,
      name: data.name,
      displayName: data.displayName,
      permissions: [...(data.permissions || [])],
      isSystem: false,
    };
    _roles.push(role);
    return clone(role);
  });
}

export function adminUpdateRole(id, data) {
  if (!isMockMode('roles')) return request(`/api/admin/roles/${id}`, { method: 'PATCH', body: data });
  return mockResponse(() => {
    const role = _roles.find(r => r.id === id);
    if (role) {
      if (data.displayName !== undefined) role.displayName = data.displayName;
      if (data.permissions !== undefined) role.permissions = [...data.permissions];
    }
    return role ? clone(role) : null;
  });
}

export function adminDeleteRole(id) {
  if (!isMockMode('roles')) return request(`/api/admin/roles/${id}`, { method: 'DELETE' });
  return mockResponse(() => {
    _roles = _roles.filter(r => r.id !== id);
    return null;
  });
}
